import * as React from 'react';
import { UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { GenericTabViewModel, GenericTabViewModelImpl } from '../../../toolkit/tabs/generictabviewmodel';
import { GenericTabComponent } from '../../../toolkit/tabs/generictabcomponent';
import { ToneViewModelImpl } from '../../../toolkit/toneoptions/tone/toneviewmodel';
import { ArtistViewModelImpl } from '../../../toolkit/toneoptions/artist/artistviewmodel';
import { SearchComponentProps, SearchTabComponentHandler, SearchComponentHandler, SearchComponentState } from './searchcomponent';
import { SearchCSSStyle } from './searchcss';
import { Strings } from '../../../../utils/resources/strings';
import { TabViewModelImpl } from '../../../toolkit/tabs/tab/tabviewmodel';
import { SpecificSearchToneDto } from '../../../../core/dto/specificsearchtone/specificsearchtonedto';
import { SearchListTabViewModelImpl } from './playlist/searchlisttabviewmodel';
import { CRBTUIViewImpl } from '../crbt/crbtuiview';
import { ArtistTabSearchListTabViewModelImpl } from './artist/artistsearchlisttabviewmodel';

export class SearchViewImpl extends CRBTUIViewImpl implements SearchTabComponentHandler
{
    private genericTabViewModel: GenericTabViewModel;
    private tonesTab: TabViewModelImpl;
    private artistTab: TabViewModelImpl;

    constructor(offset: number, basecontext: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(basecontext, uiComponentHandler);

        this.onLoadMore = this.onLoadMore.bind(this);
        this.genericTabViewModel = new GenericTabViewModelImpl();
        this.tonesTab = new SearchListTabViewModelImpl(basecontext,
            basecontext.getResources().getString(Strings.tones), new ToneViewModelImpl(offset, basecontext), this);

        this.artistTab = new ArtistTabSearchListTabViewModelImpl(basecontext, 
            basecontext.getResources().getString(Strings.artist), new ArtistViewModelImpl(offset, basecontext), this);

        this.genericTabViewModel.addTab(this.tonesTab);
        this.genericTabViewModel.addTab(this.artistTab);
    }
    
    getChildComponent(props: SearchComponentProps, state: SearchComponentState, cssStyle: SearchCSSStyle): JSX.Element
    {
        return (
          <div style={cssStyle.getWrapperCSSStyle()}>
              <GenericTabComponent onTabSelected={()=>{}} headerTitle={props.context.getResources().getString(Strings.search_results_for) + " \""  + state.searchKey + "\""} initialTab={props.context.getResources().getString(Strings.tones)} genericTabViewModel={this.genericTabViewModel} context={props.context}/>
          </div>
        );
    }

    getNavigationPath()
    {
        return [this.getUIProps().context.getResources().getString(Strings.home), this.getUIProps().context.getResources().getString(Strings.search_results)];
    }

    getBannerImg()
    {
        return "search.jpg";
    }

    updateTabData(specifiDto: SpecificSearchToneDto)
    {
        console.log("onsuccess resetPaginationCount");

        (this.tonesTab as SearchListTabViewModelImpl).updateTabData(specifiDto.getToneList());
        (this.artistTab as ArtistTabSearchListTabViewModelImpl).updateTabData(specifiDto.getCountList().getArtistDetailList());
    }

    resetPaginationState()
    {
        (this.tonesTab as SearchListTabViewModelImpl).resetPaginationCount();
        (this.artistTab as ArtistTabSearchListTabViewModelImpl).resetPaginationCount();
    }

    onLoadMore(startIndex: number, offset: number): void 
    {
       (this.getUIComponentHandler() as SearchComponentHandler).onLoadMore(startIndex, offset);
    }

    updateLoadMoreData(specifiDto: SpecificSearchToneDto)
    {
        if(this.genericTabViewModel.getSelectedTabTitle() === this.getUIProps().context.getResources().getString(Strings.tones))
        {
            (this.tonesTab as SearchListTabViewModelImpl).updateLoadMoreTabData(specifiDto.getToneList());
            (this.tonesTab as SearchListTabViewModelImpl).updatePaginationCount();
        }
        else
        {
            (this.artistTab as ArtistTabSearchListTabViewModelImpl).updateLoadMoreTabData(specifiDto.getCountList().getArtistDetailList());
            (this.artistTab as ArtistTabSearchListTabViewModelImpl).updatePaginationCount();
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/search/searchview.tsx